interface IDetailPageLayout {
  children: JSX.Element | JSX.Element[];
  hasSeperateHeader?: boolean;
}

const DetailPageLayout = ({
  children,
  hasSeperateHeader,
}: IDetailPageLayout): JSX.Element => {
  return (
    <div className="mt-[1.5rem] desktop:m-auto desktop:mt-[4.5rem] desktop:max-w-[90rem] desktop:px-[32px] desktopLarge:px-[148px]">
      {hasSeperateHeader ? (
        <div className="mt-8 ml-0 flex flex-col gap-[3.5rem] desktop:mt-[4.5rem]">
          {children}
        </div>
      ) : (
        <>{children}</>
      )}
    </div>
  );
};

export default DetailPageLayout;
